import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { useNavigate } from "react-router-dom";
import {
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Box,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { Alert } from "@mikros/shared-ui";
import { FetchAllUsers } from "@mikros/library";
import ApiServices from "../../../service/apiService";
import { Dialog } from "@progress/kendo-react-dialogs";
import { CreateUser } from "./createUser";

export interface SearchUserDupProps {
  formTypeFunction: Function;
  searchUserState: Function;
  createUserState: Function;
  userData: FetchAllUsers;
  userDataFunction: Function;
  search: boolean;
  searchFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  formData: any;
  formDataFunction: Function;
  gridDataExtractFunction: Function;
  dataGridItemFunction: Function;
  refreshDataReference: any;
  updateDataRef: any;
  selectedLanguage: any;
  selectedLanguageFunction: Function;
  languages: any;
  selectedStatus: any;
  selectedStatusFunction: Function;
  hasMoreData?: Boolean;
  hasMoreDataFunction?: Function;
}
export function SearchUserDup(props: SearchUserDupProps) {
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
  const allValue = "All";
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [downloadUserSuccess, setDownloadUserSuccess] =
    useState<boolean>(false);
  const [gridData, setGridData] = useState({});
  const [formType, setFormType] = useState<boolean>(false);
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [fetchedDataBefore, setFetchedDataBefore] = useState(false);
  const [errors, setErrors] = useState<any>();
  const pageRef = useRef(0); // Stores the last visited page
  const lastKeyRef = useRef(""); // Stores the lastKey for pagination

  const [lastKey, setLastKey] = useState<any>("");
  const [showSearchUser, setSearchUser] = useState(true);
  const [showCreateUser, setCreateUser] = useState(false);

  console.log("search val in search user dup afdafdfadsfasfasfa", props.search);
  console.log("props has more data", props.hasMoreData);

  console.log("page value in search user", page);
  console.log("last key value in search user", lastKey);

  console.log("error code flag value print", errorFlag);
  console.log("fetch all users data", props?.userData);
  console.log("grid data print", gridData);
  console.log("refresh data val print", props?.refreshDataReference?.current);

  console.log("has more data ref afasfasfas", props?.hasMoreData);

  console.log("fetched data before", fetchedDataBefore);

  const toTitleCase = (value: any) => {
    if (typeof value === "string") {
      return value?.charAt(0)?.toUpperCase() + value?.slice(1)?.toLowerCase();
    }
    return value ?? ""; // Return the original value if not a string, or "N/A" if null/undefined
  };

  const paginatedData = props?.search
    ? rowsPerPage === -1
      ? props?.userData?.users
      : props?.userData?.users?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
    : rowsPerPage === -1
    ? props?.userData?.users
    : props?.userData?.users?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
  console.log("paginated data", paginatedData);
  console.log(
    "update data Ref value in search user",
    props?.updateDataRef?.current
  );
  console.log("props search value", props?.search);

  const handleItemClick = (lang: string) => {
    let updatedSelection = [...props.selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...props.languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === props.languages.length) {
      updatedSelection = [...props.languages];
    }
    // setSelectedLanguage(updatedSelection);
    props.selectedLanguageFunction(updatedSelection);
  };

  // const handleRowsPerPageChange = (event: { target: { value: string } }) => {
  //   props.formDataFunction({
  //     designation: "", // Reset all fields to empty or their default value
  //     firstName: "",
  //     branchName: "",
  //     location: "",
  //     department: "",
  //   });
  //   const newRowsPerPage = parseInt(event.target.value, 10);
  //   console.log("Rows per page change value:", newRowsPerPage);

  //   setRowsPerPage(newRowsPerPage);
  //   setPage(0); // Reset to first page
  //   // props.pageFunction(0)

  //   setLastKey(null); // Reset pagination key
  //   // setTotalUsers(0)// reset user count
  //   props.searchFunction(false);
  //   props.userDataFunction({ users: [] }); // clear previous user data
  //   props.selectedLanguageFunction([allValue]);

  //   props.selectedStatusFunction("active");
  //   handleItemClick(allValue);

  //   fetchUsers(newRowsPerPage, ""); // Use newRowsPerPage directly
  // };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value:", newRowsPerPage);

    setRowsPerPage(newRowsPerPage);

    if (!props.search) {
      props.formDataFunction({
        firstName: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });

      setPage(0); // Reset to first page
      setLastKey(null); // Reset pagination key
      props.searchFunction(false);
      props.userDataFunction({ users: [] }); // Clear previous user data
      props.selectedLanguageFunction([allValue]);
      props.selectedStatusFunction("active");
      handleItemClick(allValue);
      fetchUsers(newRowsPerPage, ""); // Use newRowsPerPage directly
    }
  };

  const toggleDownloadUserSuccess = () => {
    setDownloadUserSuccess(!downloadUserSuccess);
  };

  const handleClearAll = () => {
    // props.userStatusFunction("active");
    console.log("inside handle clear all for search user dup");

    const hasValues = Object.values(props?.formData).some(
      (value) => value !== ""
    );

    if (!hasValues) {
      console.log("No values to clear. Exiting handleClearAll.");
      return; //  Skip API call if all fields are empty
    }

    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
      email: "",
      phNo: "",
    });
    setErrors({});

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          // `${accountInstance.accntId}/user/filter`,
          `${accountInstance.accntId}/user?limit=20`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props?.userDataFunction(data);
            props.totalCountFunction(data?.users?.length);
            // props.searchFunction(true);
            props.searchFunction(false);
            props.selectedStatusFunction("active");
            handleItemClick(allValue);
          }
        });
    }
  };
  const totalPages =
    props?.userData?.users?.length > 0
      ? Math.ceil(props?.userData?.users?.length / rowsPerPage)
      : 1;

  const handleGridItemClick = (data: any) => {
    console.log("page clicked inside grid", page);
    if (!data) {
      console.error("row data is undefined", data);
      return;
    }
    console.log("inside handle grid item click function");
    // const { dataItem } = data;
    console.log("click grid", data);
    props.searchUserState(false);
    props.createUserState(true);
    props.gridDataExtractFunction({ dataItems: data });
    props.formTypeFunction(true);
    setPage(page);
    setLastKey(lastKey);
    handleClearAll();
    console.log("print user id on click", data?.userId);
  };
  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");

    if (!loading && !props.search) {
      props.refreshDataReference.current = true; //  Enable data loading on user action

      // if (props.hasMoreDataReference.current) {
      //   fetchUsers(rowsPerPage, lastKey); //  Fetch only if more data exists
      // }

      if (props.hasMoreData) {
        fetchUsers(rowsPerPage, lastKey);
      }
    }
  };

  function fetchUsers(limit: number, key: string) {
    let api = ApiServices.getInstance();
    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/user`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
            // props.hasMoreDataReference.current = !!data?.lastKey;

            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);

      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLastKey(data.lastKey);
            // props.hasMoreDataReference.current = !!data?.lastKey;
            console.log("data last key when limit 20", data?.lastKey);
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }

    //need to check if correct// because duplicated maybe present
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/user?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data?.errorMessage);
            return;
          } else {
            // Append only when paginating
            props.userDataFunction((prevData: any) => ({
              ...prevData,
              users: [...prevData?.users, ...data?.users],
            }));
            props.totalCountFunction(
              (prevCount: any) => prevCount + (data?.users?.length || 0)
            );
            setLastKey(data.lastKey);
            console.log("data last key when last key not null", data?.lastKey);

            // props.hasMoreDataReference.current = !!data?.lastKey;
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }
  }
  useEffect(() => {
    if (!fetchedDataBefore && props?.refreshDataReference?.current) {
      console.log("inside use effect where I am fetching data");

      fetchUsers(rowsPerPage, lastKey);
    }
  }, [accountInstance.accntId, fetchedDataBefore]);
  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);

  return (
    <div>
      {downloadUserSuccess && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.searchUser.exportToCSVSuccess",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleDownloadUserSuccess();
            }}
          />
        </Dialog>
      )}
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/users");
              }
            }}
          />
        </Dialog>
      )}
      {showCreateUser && (
        <div className="pb-[10%]">
          <CreateUser
            createState={setCreateUser}
            searchState={setSearchUser}
            dataGridItems={gridData}
            formType={formType ? "EDIT" : "NEW"}
            formTypeFunction={setFormType}
          />
        </div>
      )}

      <TableContainer
        component={Paper}
        style={{
          overflowX: "auto",
          width: "100%",
          backgroundColor: "var(--color-mk-primary-10) !important",
        }}
        elevation={0}
      >
        <Table sx={{ width: "max-content", tableLayout: "auto" }} size="medium">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "var(--color-mk-primary-10) !important",
                },
              }}
            >
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.fname"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lname"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.status"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.language"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "7%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.phNo"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.email"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.employee"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dob"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dateOfJoin"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lastWorkingDate"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.gender"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.department"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.desg"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.location"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "11%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.branch"></FormattedMessage>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData?.length > 0 ? (
              paginatedData?.map(
                (
                  user: {
                    userId: any;
                    email: string;
                    phNo: string;
                    userProfile: {
                      firstName:
                        | string
                        | number
                        | boolean
                        | ReactElement<any, string | JSXElementConstructor<any>>
                        | Iterable<ReactNode>
                        | ReactPortal
                        | null
                        | undefined;
                      lastName:
                        | string
                        | number
                        | boolean
                        | ReactElement<any, string | JSXElementConstructor<any>>
                        | Iterable<ReactNode>
                        | ReactPortal
                        | null
                        | undefined;
                      dob: string | number | Date;
                      gender: any;
                    };
                    status:
                      | string
                      | number
                      | boolean
                      | ReactElement<any, string | JSXElementConstructor<any>>
                      | Iterable<ReactNode>
                      | ReactPortal
                      | null
                      | undefined;
                    prefrdLanguage:
                      | string
                      | number
                      | boolean
                      | ReactElement<any, string | JSXElementConstructor<any>>
                      | Iterable<ReactNode>
                      | ReactPortal
                      | null
                      | undefined;
                    empId: any;
                    dateOfJoin: string | number | Date;
                    lastWorkingDate: string | number | Date;
                    department: any;
                    designation: any;
                    location: any;
                    branchName: any;
                  },
                  index: any
                ) => (
                  <TableRow
                    sx={{
                      backgroundColor: "var(--color-mk-primary-10) !important",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor:
                          "var(--color-mk-primary-20) !important",
                      },
                    }}
                    key={user.userId || index}
                    onClick={() => handleGridItemClick(user)} // Pass the row data if needed
                  >
                    <TableCell>{user?.userProfile?.firstName}</TableCell>
                    <TableCell>{user?.userProfile?.lastName}</TableCell>
                    <TableCell>{toTitleCase(user?.status)}</TableCell>
                    <TableCell>
                      {user?.prefrdLanguage === "user.createUser.selectLanguage"
                        ? ""
                        : user?.prefrdLanguage}
                    </TableCell>
                    {/* <TableCell>{user?.userProfile?.phNo}</TableCell>
                    <TableCell>{user?.userProfile?.email}</TableCell> */}

                    <TableCell>{user?.phNo === "N/A" ? "" : user?.phNo}</TableCell>
                    <TableCell>{user?.email}</TableCell>
                    <TableCell>{user?.empId || ""}</TableCell>
                    <TableCell>
                      {user?.userProfile?.dob
                        ? new Date(user?.userProfile?.dob).toLocaleDateString()
                        : ""}
                    </TableCell>
                    <TableCell>
                      {user?.dateOfJoin
                        ? new Date(user?.dateOfJoin).toLocaleDateString()
                        : ""}
                    </TableCell>

                    <TableCell>
                      {user?.lastWorkingDate
                        ? new Date(user?.lastWorkingDate).toLocaleDateString()
                        : ""}
                    </TableCell>

                    <TableCell>
                      {toTitleCase(user?.userProfile?.gender || "")}
                    </TableCell>
                    <TableCell>{user?.department || ""}</TableCell>
                    <TableCell>{user?.designation || ""}</TableCell>
                    <TableCell>{user?.location || ""}</TableCell>
                    <TableCell>{user?.branchName || ""}</TableCell>
                  </TableRow>
                )
              )
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="users.addNewUser.noUser" />
                  </div>
                </TableCell>
              </TableRow>
            )
            }
          </TableBody>
        </Table>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            // backgroundColor: "#F5F6FD",
            backgroundColor: "var(--color-mk-primary-10) !important",
            padding: 0, // Removes padding
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text" //Removes border and background color
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        !props?.hasMoreData &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        !props?.hasMoreData &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                15,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              count={props.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} 
       
              ${intl.formatMessage({ id: "ofValue" })}
               ${count}
               ${intl.formatMessage({ id: "items" })}
                `
              }
              ActionsComponent={() => null} // to remove navigation buttons
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>
    </div>
  );
}
